// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TooltipContent_wrapper__Oy8yk","tooltip":"TooltipContent_tooltip__w9n2i"};